import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, provide, readonly, onMounted } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { MissionLifecycleFragmentFragment, MissionPricingProposal } from "@/gql"
import AppEditorWindow from "@/components/layout/AppEditorWindow.vue"
import PricingEditor2 from "@/components/missions/PricingEditor2.vue"
import useRouter from "@/router/useRouter"
import Previewable from "@/components/layout/Previewable.vue"
import { useAccountContext } from "@/hooks/useAccountContext"
import MoneyDisplay from "@/components/feature/MoneyDisplay.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'PricingProposal',
  props: {
    mission: null,
    pricingProposal: null
  },
  setup(__props: any) {

const props = __props as {
  mission: MissionLifecycleFragmentFragment
  pricingProposal: MissionPricingProposal
}


const { router } = useRouter()
const { isCoreTeam: isUserInCoreTeam } = useAccountContext()

const refetchQueries = computed(() => {
  return {
    mission: {
      query: "MissionLifecyclesQuery",
      variables: {
        filter: {
          idIn: [router.currentRoute.params.id],
        },
      },
    },
  }
})

provide("refetchQueries", readonly(refetchQueries.value))

const showEditPricingModal = ref(false)
const scopeSection = ref("pricing")
const editPricingModal = ref(null)
const showPricingProposalPreview = ref(false)

const onEditScopeDialogChange = (page: string) => {
  scopeSection.value = page
}

const missionScope = computed(() => {
  return props.mission?.missionScope
})

const onPricingSave = () => {
  editPricingModal.value && (editPricingModal.value as any).save()
}

const pricingEditor = ref<InstanceType<typeof PricingEditor2> | null>(null)

onMounted(() => {
  isUserInCoreTeam && pricingEditor.value?.updateTotalPrice()
})

return { __sfc: true,props, router, isUserInCoreTeam, refetchQueries, showEditPricingModal, scopeSection, editPricingModal, showPricingProposalPreview, onEditScopeDialogChange, missionScope, onPricingSave, pricingEditor, Icon, AppEditorWindow, PricingEditor2, Previewable, MoneyDisplay }
}

})